import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MenuIcon from "@mui/icons-material/Menu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SaveIcon from "@mui/icons-material/Save";
import IosShareIcon from "@mui/icons-material/IosShare";
import LabelIcon from "@mui/icons-material/Label";
import LabelOffIcon from "@mui/icons-material/LabelOff";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import RefreshIcon from "@mui/icons-material/Refresh";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

function ConversionFunnelOptions({
  existing,
  isOwner,
  handleCreateNew,
  handleRename,
  handleSaveAs,
  handleSave,
  handleSetAsDefault,
  handleClearDefault,
  handleChangeAccessList,
  handleLoad,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, handler) => {
    handleClose(event);
    if (typeof handler === "function") {
      handler();
    }
  };

  const defaultMenuItems = [
    {
      label: "Load",
      onClick: (event) => {
        handleMenuItemClick(event, handleLoad);
      },
      icon: <FileOpenIcon />,
    },
    {
      label: "Save",
      onClick: (event) => {
        handleMenuItemClick(event, handleSave);
      },
      icon: <SaveIcon />,
    },
    {
      label: "Clear",
      onClick: (event) => {
        handleMenuItemClick(event, handleCreateNew);
      },
      icon: <RefreshIcon />,
    },
    {
      label: "Make a copy",
      onClick: (event) => {
        handleMenuItemClick(event, handleSaveAs);
      },
      icon: <ContentCopyIcon />,
      existingOnly: true,
    },
    {
      label: "Rename",
      onClick: (event) => {
        handleMenuItemClick(event, handleRename);
      },
      icon: <DriveFileRenameOutlineIcon />,
      ownerOnly: true,
    },
    {
      label: "Set as default",
      onClick: (event) => {
        handleMenuItemClick(event, handleSetAsDefault);
      },
      icon: <LabelIcon />,
      existingOnly: true,
    },
    {
      label: "Clear default",
      onClick: (event) => {
        handleMenuItemClick(event, handleClearDefault);
      },
      icon: <LabelOffIcon />,
      existingOnly: true,
    },
    {
      label: "Share",
      onClick: (event) => {
        handleMenuItemClick(event, handleChangeAccessList);
      },
      icon: <IosShareIcon />,
      existingOnly: true,
      ownerOnly: true,
    },
  ];

  // const [menuItems, setMenuItems] = useState(defaultMenuItems);
  const menuItems = defaultMenuItems;

  const isMenuItemDisabled = (menuItem) => {
    if (menuItem.existingOnly && !existing) {
      return true;
    }
    if (menuItem.ownerOnly && !isOwner) {
      return true;
    }
    return false;
  };

  // useEffect(() => {
  //   let menu = defaultMenuItems;
  //   if (!isOwner) {
  //     menu = menu.filter((item) => !item.ownerOnly);
  //   }
  //   setMenuItems(menu);
  // }, [isOwner]);

  return (
    <>
      <MoreHorizIcon
        sx={{
          p: 0,
          ":hover": {
            cursor: "pointer",
          },
        }}
        onClick={handleClick}
      >
        <MenuIcon />
      </MoreHorizIcon>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        {menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.label}
            onClick={menuItem.onClick}
            disabled={isMenuItemDisabled(menuItem)}
          >
            <ListItemIcon>{menuItem.icon}</ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              {menuItem.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ConversionFunnelOptions;
